import React from "react";
import { styled, Unstable_Grid2 as Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

const ItemAddress = styled("div")(({ theme }) => ({
  background: "#F3F3F3",
  borderRadius: 8,
  padding: "1rem",
  height: "100%",
  "> .title": {
    fontFamily: "Patua One",
    fontSize: "18px",
    lineHeight: "1",
    fontWeight: 400,
    marginBottom: "8px",
  },
  "> .address": {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "1",
    letterSpacing: "0.01em",
    marginBottom: "8px",
  },
}));

const SectionAddress = ({ address = {} }) => {
  const { t } = useTranslation();

  return (
    <Grid container spacing={0} sx={{ m: 0 }} columnSpacing={{ xs: 0, sm: 3, md: 6 }} rowSpacing={{ xs: 3, sm: 0, md: 3 }}>
      <Grid xs={12} sm={6}>
        <ItemAddress>
          <h2 className="title">{t("ppp.address.tus_datos")}</h2>
          <p className="address">{address.recipient_name}</p>
          <p className="address">
            {address.line1}, {address.city}, {address.state}
          </p>
          <p className="address">
            CP {address.postal_code}, {address.country}
          </p>
        </ItemAddress>
      </Grid>

      <Grid xs={12} sm={6}>
        <ItemAddress>
          <h2 className="title">NEUBOX</h2>
          <p className="address">Av López Mateos Norte 391</p>
          <p className="address">Col. Ladrón de Guevara, Guadalajara, Jalisco</p>
          <p className="address">CP 44680, México</p>
        </ItemAddress>
      </Grid>
    </Grid>
  );
};

export default SectionAddress;
